export function getGameplayRendererVariables(gameplayRendererWidth: number) {
  const unit = gameplayRendererWidth / 100;
  return {
    '--font-size': `${unit / 2}px`,
    '--space': `${unit}px`,
  };
}
